import { ErrorMessage } from './styles';
export { ErrorMessage };
//# sourceMappingURL=InputErrorMessage.js.map